module.exports = __webpack_public_path__ + "img/0.8620f4c9.png";